import { render } from "./TooltipPanel.vue?vue&type=template&id=5a156b70&scoped=true"
import script from "./TooltipPanel.vue?vue&type=script&lang=js"
export * from "./TooltipPanel.vue?vue&type=script&lang=js"

import "./TooltipPanel.vue?vue&type=style&index=0&id=5a156b70&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5a156b70"

export default script